// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
require('es6-promise').polyfill()

import './assets/fbLogin.js'

import Vue from 'vue'
import App from './App'
import VueI18n  from 'vue-i18n'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAnalytics from 'vue-analytics'

import BootstrapVue from 'bootstrap-vue'

//import FBSignInButton from 'vue-facebook-signin-button'

Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(VueI18n)
Vue.config.productionTip = false;


import zh_tw from './lang/zh_tw.json'
import en from './lang/en.json'
var messages = {
  zh_tw: zh_tw, en: en
}

// Set the language
function getParameterByName(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

var language = undefined; //Default
language = getParameterByName("lang")

if(language) {
  language = language.replace('/', '')
  setCookie("language", language);
  location.replace('/')
}
if(!language) language = getCookie('language') || 'zh_tw';

if(language == 'en') document.title = "Flu Forecasting Station";
var i18n = new VueI18n({
  // locale: getCookie('language') || 'zh_tw', // default en
  locale: language,
  messages: messages
})
//Cookies setting
function setCookie(c_name, value, expiredays) {
  var exdate = new Date();　　　　
  exdate.setDate(exdate.getDate() + expiredays);　　　　
  document.cookie = c_name + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString());
}
Vue.prototype.$setCookie = setCookie;

function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return (arr[2]);
  else
    return null;
}
Vue.prototype.$getCookie = getCookie;

//Delete cookies
function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null)
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}
Vue.prototype.$delCookie = delCookie;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  i18n: i18n,
  template: '<App/>',
  mounted: function(){
    window.fbAsyncInit = function() {
      FB.init({
          appId      : '1253337601477245',
          cookie     : true,
          xfbml      : true,
          version    : 'v2.11'
      });

      FB.AppEvents.logPageView();

      };
  }
})

Vue.use(VueAnalytics, {
  id: 'UA-116132988-1',
  router
})




// WEBPACK FOOTER //
// ./src/main.js